import { ComputeFieldComponent } from "../computeFields";
import { Bibliography } from "../types";
import { DimensionsFormatting } from "./shared/dimensions";
import { SeparatedList } from "./shared/utils";

export const BibliographieDimensionsCF: ComputeFieldComponent<
  Pick<Bibliography, "bibliographieDescriptionDimensions">
> = ({ input, ...props }) => {
  return (
    <DimensionsFormatting
      input={{ ...input.bibliographieDescriptionDimensions }}
      {...props}
    />
  );
};

export const BibliographieLongSummaryCF: ComputeFieldComponent<
  Pick<
    Bibliography,
    | "bibliographieDescriptionNomRevue"
    | "bibliographieDescriptionAuteur"
    | "bibliographieDescriptionTitre"
    | "bibliographieDescriptionNumeroRevue"
    | "bibliographieDescriptionDatesPublication"
    | "bibliographieDescriptionPageArticle"
    | "bibliographieDescriptionSousTitre"
    | "bibliographieDescriptionVille"
    | "bibliographieDescriptionEditeur"
    | "bibliographieDescriptionCollection"
    | "bibliographieDescriptionAnnee"
  >
> = ({ input, lineBreak = false, ...props }) => {
  if (input.bibliographieDescriptionNomRevue) {
    return (
      <SeparatedList
        {...props}
        lineBreak={lineBreak}
        input={[
          input.bibliographieDescriptionAuteur,

          input.bibliographieDescriptionTitre && (
            <>« {input.bibliographieDescriptionTitre} »</>
          ),

          input.bibliographieDescriptionNomRevue && (
            <i>{input.bibliographieDescriptionNomRevue}</i>
          ),

          input.bibliographieDescriptionNumeroRevue && (
            <>n°{input.bibliographieDescriptionNumeroRevue}</>
          ),

          input.bibliographieDescriptionDatesPublication,

          input.bibliographieDescriptionPageArticle &&
            input.bibliographieDescriptionPageArticle !==
              encodeURI("n. p.") && (
              <>p. {input.bibliographieDescriptionPageArticle}</>
            ),
        ]}
      />
    );
  }

  return (
    <SeparatedList
      {...props}
      lineBreak={lineBreak}
      input={[
        input.bibliographieDescriptionAuteur,
        <i>{input.bibliographieDescriptionTitre}</i>,
        input.bibliographieDescriptionSousTitre,
        input.bibliographieDescriptionVille,
        input.bibliographieDescriptionEditeur,
        input.bibliographieDescriptionCollection,
        input.bibliographieDescriptionAnnee,
      ]}
    />
  );
};
